import type { MomentInput } from 'moment'
import moment from 'moment'

/**
 * Check if the day is the last day before DST change
 *
 * DST stands for daylight saving time, more info on:
 * https://www.timeanddate.com/time/dst/2022.html
 */
export const isDayBeforeDST = (date: MomentInput) => {
  const currentDate = moment(date)
  const dayAfter = moment(date).add(1, 'day')

  return moment(currentDate).isDST() !== moment(dayAfter).isDST()
}
